/**
 * <PosterPreview />
 *
 * SHARED: This is shared with Yellow Page.
 *
 * @parent anybody
 * @children
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './PosterView.scss';
import moment from 'moment';
import ProfileInfo from './ProfileInfo';
import DateCard from './DateCard';
import DateCardMobile from './DateCardMobile';
import Register from './Register';
import SocialMediaButton from 'shared/SocialMediaButton';
import OrderOverview from './OrderOverview';
import { alert } from 'util/alert';
import RegisterClassModal from 'shared/RegisterClassModal';
import locale from './locale';

class PosterPreview extends React.Component {
  static propTypes = {
    posterDetail: PropTypes.object.isRequired,
    hideShareButtons: PropTypes.bool,
  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.posterTypeVerbose = [
      __('Enrollment Registration', locale),
      __('Event Registration', locale),
      __('Survey', locale),
      __('Basic Poster', locale),
    ];

    let {
      poster_info,
      content,
      ticket,
    } = props.posterDetail;

    this.state = {
      poster_info,
      content,
      ticket,
      ...this.getPosterVerbose(poster_info),
    }

    this.getPosterVerbose = this.getPosterVerbose.bind(this);
    this.renderDateInfo = this.renderDateInfo.bind(this);
    this.renderMobileDateInfo = this.renderMobileDateInfo.bind(this);
    this.setOrderInfo = this.setOrderInfo.bind(this);
    this.onClickRegister = this.onClickRegister.bind(this);
  }

  onClickRegister(e) {
    const { posterDetail } = this.props;

    const { school } = posterDetail.poster_info;
    const {ticket} = posterDetail

    let hasPayment = false;
    ticket.map((t) => {
      if(t.price_type != 0){
        hasPayment = true
      }
    })

    let browser_type;
    let mobile = false;
    if( navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)){
      mobile = true
    }

    if(/micromessenger/i.test(navigator.userAgent)){
      browser_type = 'weChatBrowser'
    } else if(mobile){
      browser_type = 'mobileBroswer'
    } else {
      browser_type = 'pcBrowser'
    }

    if(hasPayment == true && browser_type == 'weChatBrowser'){
      alert.message(__('Unable to process online payment on WeChat, please register with PC broswers', locale))
      .then(() => {})
      .catch(() => {})
    } else {
      RegisterClassModal({
        posterDetail,
        schoolId: school,
      })
      .then((res)=>{
        const { result, orderInfo, order_number } = res;
        if (result === 'success') {
          this.setOrderInfo(orderInfo, order_number);
        } else {
        }
      });
    }
  }

  componentWillMount() {
    this.setPageUrl();
  }

  setOrderInfo(orderInfo,order_number) {
    this.setState({
      orderInfo,
      order_number
    });
  }

  setPageUrl() {
    const {
      id,
    } = this.state.poster_info;

    let pageUrl;

    const language = localStorage.getItem('language');

    if (process.env.NODE_ENV === 'development') {
      pageUrl = `https://posterdev.classtop.com/${id}?language=${language}`;
    } else {
      pageUrl = `https://poster.classtop.com/${id}?language=${language}`;
    }

    this.setState({
      pageUrl,
    });
  }

  render() {
    let {
      content,
      ticket,

      type,
      title,
      school_logo,
      school_name,
      creadAt,
      updatedAt,

      poster_info,
      orderInfo,

      pageUrl,
      order_number,
    } = this.state;

    const {
      stickyDate = false,
      scrollTop = 0,
      top = 0,
      position = 'relative',
      hideShareButtons,
      posterDetail,
    } = this.props;

    const {
      poster_type,
      state,
    } = poster_info;

    const sharable = state === 1;

    const showDateColumn = poster_type !== 3;
    const showRegister = poster_type !== 3;

    if (orderInfo) {
      // confirmation page
      return <OrderOverview orderInfo={orderInfo} poster_info={poster_info} order_number={order_number} posterDetail={posterDetail}/>
    }

    return (
      <div className='poster-view'>
        <div className='container poster-content' >
            { showDateColumn &&
              <div className='col-md-3 hidden-sm hidden-xs'>
                <div className='date-info' style={{top, position}} >
                  { this.renderDateInfo() }
                  { ticket.length > 0 && <a className='btn btn-primary register-now' onClick={this.onClickRegister}>{__('Register Now', locale)}</a> }
                </div>
              </div>
            }

            <div className={classnames({ 'col-md-9': showDateColumn, 'col-md-12': !showDateColumn })} >
              <section className='title-section hide-on-mobile'>
                <h3>{type}</h3>
                <div className='poster-title'>{title}</div>
              </section>

              <section className='info-section'>
                <div className='user-column'>
                  <ProfileInfo picture={school_logo} name={school_name} pictureHeight={36} pictureWidth={36} />
                </div>
                <div className='share-column'>
                </div>
              </section>

              <section className='mobile-date-info visible-xs'>
                { this.renderMobileDateInfo() }
              </section>

              <section className='content-section'>
                {content.map((item, key)=>{
                  return this.renderContentItem(item, key);
                })}
              </section>
            </div>
          </div>
        { ticket.length > 0 &&
          <div className='floating-register-btn visible-xs'>
            <a className='btn btn-primary register-now' onClick={this.onClickRegister}>{__('Register Now', locale)}</a>

          </div>
        }
          <div className='poster-footer hidden-xs' >
            <div className='container'>
                { showDateColumn &&
                <div className='col-md-3 date-info'></div> }
                <div className={classnames({ 'col-md-9': showDateColumn, 'col-md-12': !showDateColumn }, 'footer-content')}>
                  { showRegister && <Register posterDetail={this.props.posterDetail} setOrderInfo={this.setOrderInfo} onClickRegister={this.onClickRegister}/> }
                  { hideShareButtons !== true && sharable && <SocialMediaButton buttons={['facebook', 'twitter', 'wechat']} pageUrl={pageUrl} pageTitle={title} /> }
                </div>
            </div>
          </div>
      </div>
    )
  }

  getPosterVerbose(poster) {
    const {
      title,
      poster_type,
      created_at,
      updated_at,
      publisher_name,
      logo,
      school_name,
      school_logo,
      school
    } = poster;

    return {
      title,
      school_name,
      school_logo,
      schoolId: school,
      type: this.posterTypeVerbose[poster_type],
      creadAt: moment(created_at).format(__('MMM DD, YYYY', 'dateFormat')),
      updatedAt: moment(updated_at).format(__('MMM DD, YYYY', 'dateFormat')),
    }
  }

  renderDateInfo() {
    const {
      ticket,
      creadAt,
      updatedAt,
      poster_info
    } = this.state;

    return ticket.map((item, key)=>{
      return (
        <DateCard ticket={item} key={key} show_spots_left={this.props.posterDetail.poster_info.show_spots_left} />
      )
    });
  }

  renderMobileDateInfo() {
    const {
      ticket,
      creadAt,
      updatedAt,
      poster_info
    } = this.state;

    return ticket.map((item, key)=>{
      return (
        <DateCardMobile ticket={item} key={key} show_spots_left={this.props.posterDetail.poster_info.show_spots_left} />
      )
    });
  }

  renderContentItem(content, key) {
    const {
      content_type = "text",
      image_url,
      text,
    } = content;

    return (
      <div className='poster-content-item' key={key}>
        { (content_type === "text" || content_type === 0)  &&
          <div className='content-type-text' dangerouslySetInnerHTML={{__html: text}} >
          </div>
        }
        { (content_type === "picture" || content_type === 1) &&
          <div className='content-type-picture'>
            <img src={image_url}/>
          </div>
        }
      </div>
    );
  }
}

export default PosterPreview;



// WEBPACK FOOTER //
// ./src/shared/PosterView/index.js